(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/views/nav-big-statistics-view.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/views/nav-big-statistics-view.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};
  svs.statistics.big.commands = svs.statistics.big.commands || {};

  svs.statistics.big.views.NavBigStatisticsView = Backbone.Marionette.View.extend(
    {
      template: function(data) {
        return svs.statistics.navbig.templates.nav_big_main(data);
      },
      regions: {
        header: '.nav-big-header',
        regionFrontNav: {
          regionClass: svs.statistics.big.NavBigRegion,
          selector: '.nav-big-front'
        },
        regionBackNav: {
          regionClass: svs.statistics.big.NavBigRegion,
          selector: '.nav-big-back'
        },
        regionTempNav: {
          regionClass: svs.statistics.big.NavBigRegion,
          selector: '.nav-big-temp'
        },
        content: '.nav-big-content'
      },
      modelEvents: {},
      isOpeningRegion: false,
      events: {
        'click .js-back-button': 'navBack',
        'click .js-big-header .js-deep-link[data-teamid]': 'onClickedTeam',
        'click .js-big-header .js-deep-link[data-leagueid]': 'onClickedLeague',
        'click .js-close-button': 'navClose'
      },
      log: new svs.core.log.Logger('svs.statistics.views.NavBigStatisticsView'),
      className: 'nav-big',
      initialize: function(options) {
        this.app = options.app;
        this.model = new svs.statistics.big.models.NavBigStatisticsModel(
          options
        );
        this.headerSubview = new svs.statistics.big.views.NavBigStatisticsHeader(
          { model: this.model }
        );

        this.update(options);
        this.resetSelected();
      },
      setupLoader: function(options) {
        if (!options || !options.loaderSelector) {
          options = options || {};
          options.loaderSelector = '.nav-big-loader';
          this.$el.prepend(svs.statistics.navbig.templates.nav_big_loader());
        }
        this.loader = new svs.components.Loader(options.loaderSelector);
      },
      onRender: function() {
        this.setupLoader(this.options);
        if (this.contentView) {
          this.showChildView('content', this.contentView);
        }
      },
      update: function(options) {
        this.options = options;
        if (this.options.scrollerSelector) {
          this.getRegion('regionFrontNav').setScrollSelector(
            this.options.scrollerSelector
          );
          this.getRegion('regionBackNav').setScrollSelector(
            this.options.scrollerSelector
          );
        }

        if (this.options.animateTo) {
          this.getRegion('regionFrontNav').setAnimationDirection(
            this.options.animateTo
          );
          this.getRegion('regionBackNav').setAnimationDirection(
            this.options.animateTo
          );
        }

        this.resetAllListeners();
        this.setupListeners();
        if (_.has(this.options, 'contentView')) {
          this.contentView = this.options.contentView;
          this.closeRegionAndShow();
        }
      },
      setupListeners: function() {
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'region-back:show-team',
          this.regionBackShowTeam
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'region-back:show-league',
          this.regionBackShowLeague
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'region-back:show-match',
          this.regionBackShowMatch
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'continue-show-modal',
          this.continueShowModal
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'swap-to-front',
          this.swapToFront
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'openRegionDone',
          this.openRegionDone
        );
        this.listenTo(
          this.getRegion('regionFrontNav'),
          'animate-out-complete',
          this.animateOutComplete
        );

        this.listenTo(
          this.getRegion('regionBackNav'),
          'region-back:show-team',
          this.regionBackShowTeam
        );
        this.listenTo(
          this.getRegion('regionBackNav'),
          'region-back:show-league',
          this.regionBackShowLeague
        );
        this.listenTo(
          this.getRegion('regionBackNav'),
          'region-back:show-match',
          this.regionBackShowMatch
        );
        this.listenTo(
          this.getRegion('regionBackNav'),
          'continue-show-modal',
          this.continueShowModal
        );
        this.listenTo(
          this.getRegion('regionBackNav'),
          'swap-to-front',
          this.swapToFront
        );
        this.listenTo(
          this.getRegion('regionBackNav'),
          'openRegionDone',
          this.openRegionDone
        );

        this.listenTo(this, 'closeRegionStandard', this.closeRegionAndReset);
        this.listenTo(this, 'show-match', this.showModal);
        this.listenTo(this, 'show-team', this.showModal);
        this.listenTo(this, 'show-league', this.showModal);
        this.listenTo(this, 'show-selection', this.showSelection);
        this.listenTo(this, 'openRegion', this.openRegion);
        this.listenTo(this, 'closeRegion', this.closeRegion);
        this.listenTo(this, 'deepNav:show-team', this.deepNavShowTeam);
        this.listenTo(this, 'deepNav:show-league', this.deepNavShowLeague);
        this.listenTo(this, 'deepNav:show-match', this.deepNavShowMatch);
      },
      resetTempListeners: function() {
        if (this.bigTeamView) {
          this.bigTeamView.stopListening();
          this.stopListening(this.bigTeamView);
        }

        if (this.bigStatView) {
          this.bigStatView.stopListening();
          this.stopListening(this.bigStatView);
        }
        if (this.bigLeagueView) {
          this.bigLeagueView.stopListening();
          this.stopListening(this.bigLeagueView);
        }
      },
      resetAllListeners: function() {
        this.resetTempListeners();
        this.stopListening();

        if (this.getRegion('regionFrontNav')) {
          this.getRegion('regionFrontNav').stopListening();
        }

        if (this.getRegion('regionBackNav')) {
          this.getRegion('regionBackNav').stopListening();
        }
      },
      resetSelectedInNavigationLists: function() {
        this.selectTeam(0);
        this.selectLeague(0);
        this.selectMatch(0);
      },
      resetSelected: function() {
        this.resetSelectedInNavigationLists();
        this.resetSelectedPage();
      },
      navBack: function(event) {
        if (event) {
          this.trigger('closeRegion', this.options);
          event.preventDefault();
          return false;
        }
      },
      navClose: function(event) {
        if (event) {
          this.trigger('closeRegionStandard', {
            event: 'animate-out-complete',
            skippAnim: this.skippedAnimationWhenOpen
          });
          event.preventDefault();
          return false;
        }
      },
      onClickedTeam: function(event) {
        if (event) {
          var teamId = $(event.currentTarget).data('teamid');
          var currentLeagueId = $(
            '.js-big-header [data-leagueid != ""][data-leagueid]'
          ).data('leagueid');

          var options = {
            teamId: '' + teamId,
            app: this.app,
            bigNavRef: this,
            skippAnim: this.skippedAnimationWhenOpen
          };

          if (currentLeagueId) {
            options.currentLeagueId = '' + currentLeagueId;
          }

          if (teamId !== '' && !isNaN(teamId)) {
            this.trigger('deepNav:show-team', options);
          }

          event.preventDefault();
          return false;
        }
      },
      onClickedLeague: function(event) {
        if (event) {
          var leagueId = $(event.currentTarget).data('leagueid');

          var options = {
            leagueId: '' + leagueId,
            app: this.app,
            bigNavRef: this,
            skippAnim: this.skippedAnimationWhenOpen
          };

          if (leagueId !== '' && !isNaN(leagueId)) {
            this.trigger('deepNav:show-league', options);
          }

          event.preventDefault();
          return false;
        }
      },
      closeRegionAndShow: function() {
        this.closeRegionStandard();
        this.onRender();
      },
      closeRegionStandard: function(options) {
        this.removeHeader();
        if (this.getRegion('regionFrontNav')) {
          this.getRegion('regionFrontNav').empty(options || {});
        }
        if (this.getRegion('regionBackNav')) {
          this.getRegion('regionBackNav').empty({ skippAnim: true });
        }
        if (this.getRegion('regionTempNav')) {
          this.getRegion('regionTempNav').empty({ skippAnim: true });
        }

        this.resetSelected();
        this.reset();
      },
      reset: function(destroy) {
        if (this.bigStatView && destroy) {
          this.bigStatView.destroy();
        }

        if (this.statisticsModel) {
          this.statisticsModel.dispose();
          this.statisticsModel.stopListening();
          this.statisticsModel = null;
        }
        this.options = null;
        this.resetTempListeners();
      },
      removeHeader: function() {
        if (this.getRegion('header')) {
          this.getRegion('header').empty();
        }
        if (this.headerSubview) {
          this.headerSubview = null;
        }
      },
      showHeader: function() {
        this.removeHeader();
        this.headerSubview = new svs.statistics.big.views.NavBigStatisticsHeader(
          { model: this.model }
        );
        this.showChildView('header', this.headerSubview);
      },
      animateOutComplete: function(options) {
        this.trigger('bigNav:animate-out-complete', options);
      },
      closeRegionAndReset: function(options) {
        this.closeRegionStandard(options);
      },
      closeRegion: function() {
        if (this.isOpeningRegion) {
          return;
        }
        this.isOpeningRegion = true;
        var rmElement = this.removeSelectedPage();
        this.showHeader();

        this.showLoader(1);
        this.beforeNavigation(true);
        this.getRegion('regionBackNav').displayBackRegion(true);
        this.getRegion('regionFrontNav').empty({
          cbHandler: 'swap-to-front',
          rmElement: rmElement,
          skippAnim: this.skippedAnimationWhenOpen || false
        });
      },
      resizeRoyalSlider: function() {
        this.trigger('update-multi-swiper-size');
      },
      openRegion: function(options) {
        this.trigger('openRightRegion');
        options = _.extend({}, options);

        if (options.region) {
          if (
            options.region.el === this.getRegion('regionFrontNav').el ||
            options.region.el === this.getRegion('regionTempNav').el
          ) {
            this.tryResetTempNav(options.region.el);

            options.region.open(options);
            this.saveSelectedPage(options);
            this.showHeader();
          } else if (options.region.el === this.getRegion('regionBackNav').el) {
            options.region.open({ skippAnim: true });
          }

          if (options.region.el !== this.getRegion('regionTempNav').el) {
            this.hideLoader();
          }
        }
      },
      tryResetTempNav: function(regionEl) {
        var navBigTemp = $('.nav-big-temp');
        navBigTemp.removeClass('move-to-back');
        navBigTemp.removeClass('move-to-front');
        navBigTemp.addClass('move-to-back');

        if (regionEl === this.getRegion('regionTempNav').el) {
          navBigTemp.addClass('move-to-front');
          navBigTemp.removeClass('move-to-back');
        }
      },
      openRegionDone: function($el, el) {
        if ($el) {
          if ($el.selector !== this.getRegion('regionBackNav').el) {
            this.isOpeningRegion = false;
          }
        }

        this.hideLoader();
        this.beforeNavigation(false);
        this.getRegion('regionBackNav').displayBackRegion(false);

        this.resizeRoyalSlider();
        if (el) {
          this.showSelection();
        }

        this.trigger('bigNav:openRegionDone', this);

        if (this.pendingView) {
          this.showModal(this.pendingView);
          this.pendingView = null;
        }
      },
      removeEl: function(instance) {
        if (!instance) {
          return;
        }

        if (instance.el && instance.el.remove) {
          instance.el.remove();
          instance.el = null;
        }
        if (instance.$el && instance.$el.remove) {
          instance.$el.remove();
          instance.$el = null;
        }
      },
      cleanup: function(region) {
        if (region && region.view) {
          if (this.bigLeagueView && region.view.el === this.bigLeagueView.el) {
            this.removeEl(this.bigLeagueView);
            this.bigLeagueView = null;
          } else if (
            this.bigTeamView &&
            region.view.el === this.bigTeamView.el
          ) {
            this.removeEl(this.bigTeamView);
            this.bigTeamView = null;
          }
          this.removeEl(region.view);
        }
      },
      swapToFront: function() {
        this.cleanup(this.getRegion('regionFrontNav'));
        this.getRegion('regionBackNav').swapToFront(
          this.getRegion('regionFrontNav'),
          this.getRegion('regionBackNav').view
        );
        this.listenTo(
          this.getRegion('regionFrontNav').view,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showSelection();
        $(window.document).trigger('resizeTabView');
      },
      deepNavCreateTeam: function(options) {
        options.region = this.getRegion('regionFrontNav');
        this.getRegion('regionBackNav').displayBackRegion(true);
        this.getRegion('regionFrontNav').swapToBack(
          this.getRegion('regionBackNav')
        );
        this.doCreateTeam(options);
        this.listenTo(
          this.bigTeamView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showChildView('regionFrontNav', this.bigTeamView, options);
      },
      deepNavCreateLeague: function(options) {
        options.region = this.getRegion('regionFrontNav');
        this.getRegion('regionBackNav').displayBackRegion(true);
        this.getRegion('regionFrontNav').swapToBack(
          this.getRegion('regionBackNav')
        );

        this.doCreateLeague(options);

        this.listenTo(
          this.bigLeagueView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showChildView('regionFrontNav', this.bigLeagueView, options);
      },
      deepNavCreateMatch: function(options, match) {
        options.region = this.getRegion('regionFrontNav');
        this.getRegion('regionBackNav').displayBackRegion(true);
        this.getRegion('regionFrontNav').swapToBack(
          this.getRegion('regionBackNav')
        );
        this.doCreateMatch(options, match);
        this.listenTo(
          this.bigStatView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showChildView('regionFrontNav', this.bigStatView, options);
      },
      regionBackCreateTeam: function(options) {
        options.region = this.getRegion('regionBackNav');
        this.doCreateTeam(options);
        this.getRegion('regionBackNav').openBackRegion(this.bigTeamView);
      },
      regionBackCreateLeague: function(options) {
        options.region = this.getRegion('regionBackNav');
        this.doCreateLeague(options);
        this.getRegion('regionBackNav').openBackRegion(this.bigLeagueView);
      },
      regionBackCreateMatch: function(options, match) {
        options.region = this.getRegion('regionBackNav');
        this.doCreateMatch(options, match);
        this.getRegion('regionBackNav').openBackRegion(
          this.bigStatView,
          options
        );
      },
      continueModalCreateTeam: function(options) {
        this.doCreateTeam(options);
        this.listenTo(
          this.bigTeamView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showChildView('regionFrontNav', this.bigTeamView);
      },
      continueModalCreateLeague: function(options) {
        this.doCreateLeague(options);
        this.listenTo(
          this.bigLeagueView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
        this.showChildView('regionFrontNav', this.bigLeagueView);
      },
      doCreateLeague: function(options) {
        options.app = this.app;
        var oLeague = svs.statistics.big.commands.navBigLeagueCommand.doCreateLeague(
          options
        );
        this.bigLeagueView = oLeague.view;
        this.leagueModel = oLeague.model;
        this.listenTo(this.bigLeagueView, 'openRegion', this.openRegion);
      },
      continueModalCreateMatch: function(options, match) {
        var _self = this;
        this.doCreateMatch(options, match);
        if (_self.getRegion('regionFrontNav')) {
          _self.showChildView('regionFrontNav', _self.bigStatView);
        }
        _self.listenTo(
          _self.bigStatView,
          'resizeRoyalSlider',
          _self.resizeRoyalSlider
        );
      },
      doCreateTeam: function(options) {
        options.app = this.app;
        var oTeam = svs.statistics.big.commands.navBigTeamCommand.doCreateTeam(
          options
        );
        this.bigTeamView = oTeam.view;
        this.teamModel = oTeam.model;
        this.listenTo(this.bigTeamView, 'openRegion', this.openRegion);
      },
      resetPreDrawViews: function() {
        if (this.bigTeamPreDrawView) {
          this.stopListening(this.bigTeamPreDrawView);
          this.bigTeamPreDrawView.stopListening();
          this.bigTeamPreDrawView = null;
        }

        if (this.bigLeaguePreDrawView) {
          this.stopListening(this.bigLeaguePreDrawView);
          this.bigLeaguePreDrawView.stopListening();
          this.bigLeaguePreDrawView = null;
        }

        this.getRegion('regionTempNav').empty({ skippAnim: true });
      },
      preDrawTeam: function(options) {
        this.resetPreDrawViews();

        this.bigTeamPreDrawView = new svs.statistics.big.views.TeamBigStatisticsView(
          {
            app: this.app,
            region: this.getRegion('regionTempNav'),
            preDraw: true,
            tab: options.tab,
            skippAnim: options.skippAnim
          }
        );
        this.listenTo(this.bigTeamPreDrawView, 'openRegion', this.openRegion);
        this.getRegion('regionTempNav').displayBackRegion(true);
        this.showChildView('regionTempNav', this.bigTeamPreDrawView);
        this.listenTo(
          this.bigTeamPreDrawView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
      },
      preDrawLeague: function(options) {
        this.resetPreDrawViews();

        this.bigLeaguePreDrawView = new svs.statistics.big.views.LeagueBigStatisticsView(
          {
            app: this.app,
            region: this.getRegion('regionTempNav'),
            preDraw: true,
            tab: options.tab,
            skippAnim: options.skippAnim
          }
        );

        this.listenTo(this.bigLeaguePreDrawView, 'openRegion', this.openRegion);
        this.getRegion('regionTempNav').displayTempRegion(true, true);
        this.showChildView('regionTempNav', this.bigLeaguePreDrawView);
        this.listenTo(
          this.bigLeaguePreDrawView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
      },
      doCreateMatch: function(options, match) {
        options.app = this.app;
        var oMatch = svs.statistics.big.commands.navBigMatchCommand.doCreateMatch(
          options,
          match
        );
        this.bigStatView = oMatch.view;
        this.statisticsModel = oMatch.model;
        this.listenTo(this.bigStatView, 'openRegion', this.openRegion);
      },
      preDrawMatch: function(options) {
        this.bigStatView = new svs.statistics.big.views.BigStatisticsView({
          app: this.app,
          region: this.getRegion('regionTempNav'),
          preDraw: true,
          tab: options.tab
        });
        this.listenTo(this.bigStatView, 'openRegion', this.openRegion);
        this.getRegion('regionTempNav').displayTempRegion(true, true);
        this.showChildView('regionTempNav', this.bigStatView);
        this.listenTo(
          this.bigStatView,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
      },
      deepNavShowTeam: function(options) {
        if (this.isOpeningRegion) {
          return;
        }
        this.isOpeningRegion = true;

        if (this.bigTeamView) this.bigTeamView.stopListening();

        this.resetSelectedInNavigationLists();
        this.selectTeam(options.teamId);
        this.beforeNavigation(true);

        options.callType = svs.statistics.big.commands.DEEP_NAVIGATION;
        options.skippAnim =
          options.skippAnim || this.skippedAnimationWhenOpen || false;

        this.createContent(options);
      },
      deepNavShowLeague: function(options) {
        if (this.isOpeningRegion) {
          return;
        }
        this.isOpeningRegion = true;

        if (this.bigLeagueView) this.bigLeagueView.stopListening();

        this.resetSelectedInNavigationLists();
        this.selectLeague(options.leagueId);
        this.beforeNavigation(true);

        options.callType = svs.statistics.big.commands.DEEP_NAVIGATION;
        options.skippAnim =
          options.skippAnim || this.skippedAnimationWhenOpen || false;

        this.createContent(options);
      },
      deepNavShowMatch: function(options) {
        if (this.isOpeningRegion) {
          return;
        }
        this.isOpeningRegion = true;

        options = _.extend(
          {
            matchId: '',
            app: this,
            bigNavRef: this
          },
          options
        );

        if (this.bigStatView) this.bigStatView.stopListening();

        this.resetSelectedInNavigationLists();
        this.selectMatch(options.matchId);
        this.beforeNavigation(true);

        options.callType = svs.statistics.big.commands.DEEP_NAVIGATION;
        options.skippAnim =
          options.skippAnim || this.skippedAnimationWhenOpen || false;

        this.createContent(options);
      },
      regionBackShowTeam: function(options) {
        options = _.extend(
          {
            teamId: '',
            app: this,
            bigNavRef: this
          },
          options
        );

        this.isOpeningRegion = true;
        if (this.bigTeamView) this.bigTeamView.stopListening();

        this.beforeNavigation(true);
        this.createTeam(options, this, 'regionBackCreateTeam');
      },
      regionBackShowLeague: function(options) {
        options = _.extend(
          {
            leagueId: '',
            app: this,
            bigNavRef: this
          },
          options
        );

        this.isOpeningRegion = true;

        if (this.bigLeagueView) this.bigLeagueView.stopListening();

        this.beforeNavigation(true);
        this.createLeague(options, this, 'regionBackCreateLeague');
      },
      regionBackShowMatch: function(options) {
        this.isOpeningRegion = true;
        options = _.extend(
          {
            matchId: ''
          },
          options
        );

        if (this.bigStatView) this.bigStatView.stopListening();

        this.beforeNavigation(true);
        this.createMatch(options, this, 'regionBackCreateMatch', false);
      },
      beforeNavigation: function(tDisplay) {
        this.getRegion('regionFrontNav').beforeNavigation(tDisplay);
        this.getRegion('regionBackNav').beforeNavigation(tDisplay, true);

        this.getRegion('regionTempNav').beforeNavigation(true);
      },
      showModal: function(options) {
        options = _.extend(
          {
            app: this,
            bigNavRef: this
          },
          options
        );

        this.skippedAnimationWhenOpen = options.skippAnim || false;

        if (this.detectIdInUse(options, this.getRegion('regionFrontNav'))) {
          return;
        }

        if (this.isOpeningRegion) {
          this.pendingView = options;
          return;
        }

        this.isOpeningRegion = true;
        this.beforeNavigation(true);

        this.resetSelected();
        this.getRegion('regionTempNav').empty({ skippAnim: true });
        this.getRegion('regionBackNav').empty({ skippAnim: true });
        this.showHeader();

        if (_.has(options, 'teamId')) {
          this.selectTeam(options.teamId);
          options.cbHandler = 'continue-show-modal';
          options.oTeam = { teamId: '' + options.teamId };
          options.cbObj = options.oTeam;
          this.getRegion('regionFrontNav').empty(options);
        } else if (_.has(options, 'leagueId')) {
          this.selectLeague(options.leagueId);
          options.cbHandler = 'continue-show-modal';
          options.oLeague = { leagueId: '' + options.leagueId };
          options.cbObj = options.oLeague;
          this.getRegion('regionFrontNav').empty(options);
        } else if (_.has(options, 'matchId')) {
          this.selectMatch(options.matchId);
          options.cbHandler = 'continue-show-modal';
          options.oMatch = { matchId: '' + options.matchId };
          options.cbObj = options.oMatch;
          this.getRegion('regionFrontNav').empty(options);
        }
      },
      continueShowModal: function(options) {
        options = _.extend(
          {
            app: this,
            bigNavRef: this
          },
          options
        );

        this.reset(true);

        options.region = this.getRegion('regionFrontNav');

        this.createContent(options);
      },
      createContent: function(options) {
        if (_.has(options, 'teamId')) {
          if (
            (_.isObject(options.model) &&
              options.model instanceof
                svs.sport.sport_search.models.SearchTeamList) ||
            (_.isObject(options.model) &&
              options.model instanceof
                svs.statistics.big.models.TeamBigStatisticsModel)
          ) {
            this.createTeamContent(options);
          } else {
            this.showLoader(0);
            this.createTeam(options, this, 'preDrawTeam');
          }
        } else if (_.has(options, 'leagueId')) {
          if (
            (_.isObject(options.model) &&
              options.model instanceof
                svs.sport.sport_search.models.SearchTeamList) ||
            (_.isObject(options.model) &&
              options.model instanceof
                svs.statistics.big.models.LeagueBigStatisticsModel)
          ) {
            this.createLeagueContent(options);
          } else {
            this.showLoader(0);
            this.createLeague(options, this, 'preDrawLeague');
          }
        } else if (_.has(options, 'matchId')) {
          if (
            (_.isObject(options.model) &&
              options.model instanceof svs.statistics.models.Match) ||
            (_.isObject(options.model) &&
              options.model instanceof
                svs.statistics.big.models.BigStatisticsModel)
          ) {
            this.createMatchContent(options, true);
          } else {
            this.showLoader(0);
            this.createMatch(options, this, 'preDrawMatch', true);
          }
        }
      },
      preDrawMatchLoaded: function(options) {
        options.preDrawType = svs.statistics.big.commands.PRE_DRAW_MATCH;
        this.createMatchContent(options, false);
      },
      createMatchContent: function(options, preDraw) {
        if (options.callType === svs.statistics.big.commands.DEEP_NAVIGATION) {
          this.createMatch(options, this, 'deepNavCreateMatch', false);
        } else {
          this.createMatch(options, this, 'continueModalCreateMatch', preDraw);
        }
      },
      preDrawTeamLoaded: function(options) {
        options.preDrawType = svs.statistics.big.commands.PRE_DRAW_TEAM;
        this.createTeamContent(options);
      },
      createTeamContent: function(options) {
        if (options.callType === svs.statistics.big.commands.DEEP_NAVIGATION) {
          this.createTeam(options, this, 'deepNavCreateTeam');
        } else {
          this.createTeam(options, this, 'continueModalCreateTeam');
        }
      },
      preDrawLeagueLoaded: function(options) {
        options.preDrawType = svs.statistics.big.commands.PRE_DRAW_LEAGUE;
        this.createLeagueContent(options);
      },
      createLeagueContent: function(options) {
        if (options.callType === svs.statistics.big.commands.DEEP_NAVIGATION) {
          this.createLeague(options, this, 'deepNavCreateLeague');
        } else {
          this.createLeague(options, this, 'continueModalCreateLeague');
        }
      },
      selectTeam: function(teamId) {
        var $teams = $('#list-teams .list-group-item'),
          $selectedTeam = $teams.filter('[data-teamid=' + teamId + ']');
        $teams.removeClass('panel-inverted clickable-list-group-item-inverted');
        $selectedTeam.addClass(
          'panel-inverted clickable-list-group-item-inverted'
        );
      },
      selectLeague: function(leagueId) {
        var $leagues = $('#list-leagues .list-group-item'),
          $selectedLeague = $leagues.filter('[data-leagueid=' + leagueId + ']');
        $leagues.removeClass(
          'panel-inverted clickable-list-group-item-inverted'
        );
        $selectedLeague.addClass(
          'panel-inverted clickable-list-group-item-inverted'
        );
      },
      selectMatch: function(matchId) {
        var $matches = $('.list-group-match .match-container'),
          $selectedMatch = $matches.filter('[data-match-id=' + matchId + ']');
        $matches.removeClass('panel-inverted');
        $selectedMatch.addClass('panel-inverted');

        if (svs.core.detect.formfactor.desktop()) {
          $matches
            .find('.match-link')
            .removeClass('clickable-list-group-item-inverted')
            .addClass('clickable-list-group-item-default');
          $selectedMatch
            .find('.match-link')
            .removeClass('clickable-list-group-item-default')
            .addClass('clickable-list-group-item-inverted');
        }
      },
      showSelection: function() {
        var currentOptions = null;
        if (
          _.isObject(this.getRegion('regionFrontNav').customCurrentView) &&
          _.has(this.getRegion('regionFrontNav').customCurrentView, 'options')
        ) {
          currentOptions = this.getRegion('regionFrontNav').customCurrentView
            .options;
          this.resetSelectedInNavigationLists();
          if (_.has(currentOptions, 'teamId')) {
            this.selectTeam(currentOptions.teamId);
          } else if (_.has(currentOptions, 'leagueId')) {
            this.selectLeague(currentOptions.leagueId);
          } else if (_.has(currentOptions, 'matchId')) {
            this.selectMatch(currentOptions.matchId);
          }
        }
      },
      createTeam: function(options, cb, cbFunc) {
        var assetsLoaded = svs.statistics.big.commands.navBigTeamCommand.loadTeam(
          options,
          cb,
          cbFunc
        );
        if (!assetsLoaded) {
          this.showLoader(0);
        }
      },
      createLeague: function(options, cb, cbFunc) {
        var assetsLoaded = svs.statistics.big.commands.navBigLeagueCommand.loadLeague(
          options,
          cb,
          cbFunc
        );
        if (!assetsLoaded) {
          this.showLoader(0);
        }
      },
      createMatch: function(options, cb, cbFunc) {
        var assetsLoaded = svs.statistics.big.commands.navBigMatchCommand.loadMatch(
          options,
          cb,
          cbFunc
        );
        if (!assetsLoaded) {
          this.showLoader(0);
        }
      },
      showLoader: function(ttw) {
        this.hideLoader();

        if (ttw === 0) {
          this.loader.show();
          return;
        }

        if (!ttw) ttw = 500;

        var _self = this;
        this.loaderInterval = setTimeout(function() {
          _self.loader.show();
        }, ttw);
      },
      hideLoader: function() {
        if (this.loader) {
          this.loader.hide();
        }
        if (this.loaderInterval) {
          clearTimeout(this.loaderInterval);
        }
      },
      saveSelectedPage: function(options) {
        if (options) {
          var existing = [];
          if (this.model && this.model.get('history')) {
            existing = this.model.get('history');
          }

          if (
            options &&
            options.teamId &&
            !_.findWhere(existing, { teamId: parseInt(options.teamId, 10) })
          ) {
            existing.push({ teamId: options.teamId, label: options.label });
          } else if (
            options &&
            options.leagueId &&
            !_.findWhere(existing, { leagueId: parseInt(options.leagueId, 10) })
          ) {
            existing.push({ leagueId: options.leagueId, label: options.label });
          } else if (
            options &&
            options.matchId &&
            !_.findWhere(existing, { matchId: parseInt(options.matchId, 10) })
          ) {
            existing.push({ matchId: options.matchId, label: options.label });
          }
          if (this.model) {
            this.model.set('history', existing, { silent: true });
          }
          this.toggleBackButton(existing);
        }
      },
      removeSelectedPage: function() {
        var existing = '';
        var oElement = null;

        if (this.model && this.model.get('history')) {
          existing = this.model.get('history');
        }
        if (_.isArray(existing)) {
          if (existing.length > 0) {
            existing.splice(existing.length - 1, 1);
            oElement = existing[existing.length - 2];
          }
        }
        if (this.model) {
          this.model.set('history', existing, { silent: true });
        }

        this.toggleBackButton(existing);

        return oElement;
      },
      toggleBackButton: function(existing) {
        if (this.model) {
          if (existing.length > 1) {
            this.model.set('showBackButton', true, { silent: true });
          } else {
            this.model.set('showBackButton', false, { silent: true });
          }
        }
      },
      resetSelectedPage: function() {
        if (this.model) {
          this.model.set('history', [], { silent: true });
          this.toggleBackButton([]);
        }
      },
      detectIdInUse: function(options, region) {
        var currentId = null;
        var currentOptions = null;
        if (
          _.isObject(region.customCurrentView) &&
          _.has(region.customCurrentView, 'options')
        ) {
          currentOptions = region.customCurrentView.options;
          if (_.has(currentOptions, 'teamId')) {
            currentId = currentOptions.teamId;
          } else if (_.has(currentOptions, 'leagueId')) {
            currentId = currentOptions.leagueId;
          } else if (_.has(currentOptions, 'matchId')) {
            currentId = currentOptions.matchId;
          }
          if (
            currentId &&
            (options.teamId === currentId ||
              options.leagueId === currentId ||
              options.matchId === currentId)
          ) {
            return true;
          }
        }
        return false;
      },

      onDestroy: function() {
        this.resetAllListeners();
        if (this.headerSubview && !this.headerSubview.isDestroyed) {
          this.headerSubview.empty();
        }
        this.closeRegionStandard();

        this.headerSubview = null;
        this.contentView = null;
        this.bigStatView = null;
        this.statisticsModel = null;
        this.bigTeamView = null;
        this.teamModel = null;
        this.bigLeagueView = null;
        this.leagueModel = null;
        this.options = null;

        delete this.headerSubview;
        delete this.contentView;
        delete this.bigStatView;
        delete this.statisticsModel;
        delete this.bigTeamView;
        delete this.teamModel;
        delete this.bigLeagueView;
        delete this.leagueModel;
        delete this.options;
        delete this.bigTeamView;
        delete this.teamModel;
        delete this.bigLeagueView;
        delete this.leagueModel;
        delete this.options;
      }
    }
  );
})(Backbone, _, svs);

 })(window);